export const GET_USER = 'GET_USER';
export const SET_USER = 'SET_USER';
export const SIGN_OUT = 'SIGN_OUT';
export const PATCH_USER = 'PATCH_USER';
export const MERGE_USER_PATCH = 'MERGE_USER_PATCH';
export const SET_ACHIEVEMENT_PROGRESS_VALUES = 'SET_ACHIEVEMENT_PROGRESS_VALUES';
export const TRIGGER_WEBEX_PREDICT_MESSAGE = 'TRIGGER_WEBEX_PREDICT_MESSAGE';
export const LOGIN_AS_GUEST = 'LOGIN_AS_GUEST';
export const GET_RPM_AVATAR_GENDER = 'GET_RPM_AVATAR_GENDER';
